import React, { useMemo } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import CustomPressable from '../../customPressable/customPressable';
import { ImageComp } from '../../Image/Image';
import { useCssStyle } from '../../../customHook/getCssStyle';
import { getCleanUrl } from '../../../utils/Helper';
import RenderHTML from 'react-native-render-html';

const InfoWidget_Landscape = (props) => {
  const { listItemData = [], handleOnWidgetClick } = props || {};
  const getStyles = useCssStyle();
  const { width } = useWindowDimensions()


  if (!listItemData.length) {
    return null;
  }

  return (
    <>
      {
        listItemData.map(widgetData => {
          let widgetImg = widgetData.btnImageUrl ? getCleanUrl(widgetData.btnImageUrl) : null;
          const customWidgetTitleStyle = getStyles([
            'infoWidgetHeaderTitle_landscape',
            `infoWidgetHeaderTitle_landscape_${widgetData.widgetMetaHtmlId}`,
            `infoWidgetHeaderTitle_landscape_${widgetData.id}`,
          ]);


          const customWidgetSubTitleStyle = getStyles([
            'infoWidgetHeaderSubtitle_landscape',
            `infoWidgetHeaderSubtitle_landscape_${widgetData.widgetMetaHtmlId}`,
            `infoWidgetHeaderSubtitle_landscape_${widgetData.id}`
          ]);

          return (
            <CustomPressable 
              onPress={() => handleOnWidgetClick(widgetData)} 
              key={widgetData.id} 
              style={getStyles( ['infoWidgetsWidgetContainer_landscape', `infoWidgetsWidgetContainer_landscape_${widgetData.widgetMetaHtmlId}`, `infoWidgetsWidgetContainer_landscape_${widgetData.id}`])} 
              id={`infoWidgetsWidgetContainer_landscape infoWidgetsWidgetContainer_landscape_${widgetData.widgetMetaHtmlId} infoWidgetsWidgetContainer_landscape_${widgetData.id}`} 
            >
              {widgetImg && (
                <ImageComp
                  source={widgetImg}
                  style={getStyles(['infoWidgetImageStyle_landscape', `infoWidgetImageStyle_landscape_${widgetData.widgetMetaHtmlId}`, `infoWidgetImageStyle_landscape_${widgetData.id}`])}
                  id={`infoWidgetImageStyle_landscape infoWidgetImageStyle_landscape_${widgetData.widgetMetaHtmlId} infoWidgetImageStyle_landscape_${widgetData.id}`}
                />
              )}
              {widgetData.widgetTitle && (
                <RenderHTML
                  contentWidth={width}
                  baseStyle={customWidgetTitleStyle}
                  source={{ html: widgetData.widgetTitle }}
                  systemFonts={Array.isArray(customWidgetTitleStyle?.fontFamily) ? customWidgetTitleStyle?.fontFamily : [customWidgetTitleStyle.fontFamily]}
                  id={`infoWidgetHeaderTitle_landscape infoWidgetHeaderTitle_landscape_${widgetData.widgetMetaHtmlId} infoWidgetHeaderTitle_landscape_${widgetData.id}`}
                />
              )}
              {widgetData.widgetDesc && (
                <View style={customWidgetSubTitleStyle}>
                  <RenderHTML
                    contentWidth={width}
                    baseStyle={customWidgetSubTitleStyle}
                    source={{ html: widgetData.widgetDesc }}
                    systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                    id={`infoWidgetHeaderSubtitle_landscape infoWidgetHeaderSubtitle_landscape_${widgetData.widgetMetaHtmlId}`}
                    
                  />
                </View>
              )}
              {widgetData.buttonTitle &&
                <View 
                  style={getStyles(['infoWidgetButtonContainer_landscape', `infoWidgetButtonContainer_landscape_${widgetData.widgetMetaHtmlId}`, `infoWidgetButtonContainer_landscape_${widgetData.id}`])}
                  id={`infoWidgetButtonContainer_landscape infoWidgetButtonContainer_landscape_${widgetData.widgetMetaHtmlId} infoWidgetButtonContainer_landscape_${widgetData.id}`}
                >
                  <Text 
                    style={getStyles(['infoWidgetButtonContainerText_landscape', `infoWidgetButtonContainerText_landscape_${widgetData.widgetMetaHtmlId}`, `infoWidgetButtonContainerText_landscape_${widgetData.id}`])}
                    id={`infoWidgetButtonContainerText_landscape infoWidgetButtonContainerText_landscape_${widgetData.widgetMetaHtmlId} infoWidgetButtonContainerText_landscape_${widgetData.id}`}
                  >{widgetData.buttonTitle}</Text>
                </View>
              }
            </CustomPressable>
          )
        })
      }
    </>
  );
};

export default React.memo(InfoWidget_Landscape);